export enum GameType {
    None,
    LeagueOfLegends
}